import { Editor } from '@/lib/components/Shared/editor/TextEditor.types';
import { useEditorProps } from '@/lib/components/Shared/editor/editorProps';
import { EditorEmit, EditorEvents } from '@/lib/components/Shared/editor/EditorEvents';

const textEditorController = (props: typeof useEditorProps, emit: EditorEmit) => ({
	onBlur: () => emit(EditorEvents.Blur),
	onFocus: (element: HTMLElement | Editor) => emit(EditorEvents.Focus, element),
	onInput: (html: string) => emit(EditorEvents.Input, html),
	onKeyup: (element: HTMLElement) => emit(EditorEvents.Keyup, element),
	onUpload: () => emit(EditorEvents.Upload),
});

export { textEditorController };
